'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';
import StoreLocator from 'components/commercetools-ui/organisms/content/store-locator';

export interface StoreLocatorProps {
  data: any;
}

const StoreLocatorTastic  = ({ data }: TasticProps<StoreLocatorProps>) => {
  return <StoreLocator data={data?.data?.dataSource} />;
};

export default StoreLocatorTastic;